const ID = 'link';

export default ID;
